import { Instructor, User } from "../entities";
import { Content } from "../../../infrastructure/presentation/views/content/helpers";
import { Menu } from "./training_course";

export class EventRequest {
  event: EventCourse;
  contents: Content[];

  constructor(
    event: EventCourse = new EventCourse(),
    contents: Content[] = []
  ) {
    this.event = event;
    this.contents = contents;
  }
}

/** Face-to-face courses */
export class EventCourse {
  /** event's id. Used to identify each event individually. */
  id: number;
  classID: number;

  location: string;

  /** Event's state (it is active or inactive). */
  isActive: boolean;

  /** Event's name. */
  name: string;

  /** Event's description. Contains a resume of the event's contents. */
  description: string;

  /** Event's time duration in milliseconds. */
  duration: number;

  image: string;
  imageB64: string;
  imageExtension: string;
  bannerURL: string;
  bannerBase64: string;
  bannerExtension: string;

  /** Controls event have certification. */
  hasCertificate: boolean;

  /** Event contents' rating average. */
  rating: number;

  /** When the event will be active and visible to the user. */
  activationDate: string;

  /** When the event will be inactive and visible to the user. */
  inactivationDate: string;

  hasNewContent: boolean;
  classes: EventClass[];

  menus: Menu[];
  menu: string;
  menuMarkdown: string;
  scheduleStartDateTime: string;
  releaseStartDate: string;
  releaseEndDate: string;
  type: number;
  introductoryContent: Content | null;

  constructor(
    id: number = 0,
    classID: number = 0,
    location = "",
    isActive: boolean = false,
    name: string = "",
    description: string = "",
    duration: number = 0,
    image = "",
    imageB64: string = "",
    imageExtension: string = "",
    bannerURL: string = "",
    bannerBase64: string = "",
    bannerExtension: string = "",
    hasCertificate: boolean = false,
    rating: number = 0,
    activationDate: string = "",
    inactivationDate: string = "",
    classes = new Array<EventClass>(),
    hasNewContent = false,
    menu = "",
    menuMarkdown = "",
    scheduleStartDateTime = "",
    releaseStartDate = "",
    releaseEndDate = "",
    type = NaN,
    menus = new Array<Menu>(),
    introductoryContent = null
  ) {
    this.id = id;
    this.classID = classID;
    this.location = location;
    this.isActive = isActive;
    this.name = name;
    this.description = description;
    this.duration = duration;
    this.image = image;
    this.imageB64 = imageB64;
    this.imageExtension = imageExtension;
    this.bannerURL = bannerURL;
    this.bannerBase64 = bannerBase64;
    this.bannerExtension = bannerExtension;
    this.hasCertificate = hasCertificate;
    this.rating = rating;
    this.activationDate = activationDate;
    this.inactivationDate = inactivationDate;
    this.classes = classes;
    this.hasNewContent = hasNewContent;
    this.menu = menu;
    this.menuMarkdown = menuMarkdown;
    this.scheduleStartDateTime = scheduleStartDateTime;
    this.releaseStartDate = releaseStartDate;
    this.releaseEndDate = releaseEndDate;
    this.type = type;
    this.menus = menus;
    this.introductoryContent = introductoryContent;
  }
}

/** Contains all the information about class. Used to users enroll in. */
export class EventClass {
  /** Class identification. */
  id: number;
  /** EventClass identification. */
  eventID: number;

  /** Class name. */
  name: string;

  /** Defines if the EventClass should be visible to the allowed users. */
  isActive: boolean;

  /** Defines the place where the event will occur. */
  location: string;

  /** Defines this class is open to all users. */
  isPublic: boolean;

  /** Defines how much people are able to enroll in this class. */
  maxCapacity: number;

  /** Defines the scheduled date and time to start the event to this class. */
  scheduleStart: string;

  /** Defines the scheduled date and time to finish the event to this class. */
  scheduleEnd: string;

  /** Scheduled start time for the class. */
  scheduleStartDateTime: string;

  /** Scheduled end time for the class. */
  scheduleEndDateTime: string;

  /** Defines the scheduled date and time to allow the allowed users to enroll this class. */
  enrollmentStart: string;

  /** Defines the scheduled date and time to not allow the allowed users to enroll this class. */
  enrollmentEnd: string;

  /** Defines the definitive date and time that the event start to this class. */
  startedAt: string;

  /** Defines the definitive date and time that the event finish to this class. */
  finishedAt: string;

  /** Defines the definitive time that the event will take. */
  duration: number;

  /** Defines the schedule date to allow the allowed users see this class. */
  activationDate: string;

  /** Defines the schedule date to not allow the allowed users see this class. */
  inactivationDate: string;

  /** The list of the enrolled users
   * @see User. */
  enrollUsers: User[];

  /** The list of the event's instructors.
   * @see Instructor*/
  instructors: Instructor[];

  userCertificateUrl: string;

  hasNewContent: boolean;

  hasCertificate: boolean;

  constructor(
    id: number = 0,
    eventID: number = 0,
    name: string = "",
    isActive: boolean = false,
    location: string = "",
    isPublic: boolean = false,
    hasCertificate: boolean = false,
    maxCapacity: number = 0,
    scheduleStart: string = "",
    scheduleEnd: string = "",
    scheduleStartDateTime: string = "",
    scheduleEndDateTime: string = "",
    enrollmentStart: string = "",
    enrollmentEnd: string = "",
    startedAt: string = "",
    finishedAt: string = "",
    activationDate: string = "",
    inactivationDate: string = "",
    duration = 0,
    enrollUsers: User[] = [],
    instructors: Instructor[] = [],
    userCertificateUrl: string = "",
    hasNewContent = false
  ) {
    this.id = id;
    this.eventID = eventID;
    this.name = name;
    this.isActive = isActive;
    this.location = location;
    this.hasCertificate = hasCertificate;
    this.isPublic = isPublic;
    this.maxCapacity = maxCapacity;
    this.scheduleStart = scheduleStart;
    this.scheduleEnd = scheduleEnd;
    this.scheduleStartDateTime = scheduleStartDateTime;
    this.scheduleEndDateTime = scheduleEndDateTime;
    this.enrollmentStart = enrollmentStart;
    this.enrollmentEnd = enrollmentEnd;
    this.startedAt = startedAt;
    this.finishedAt = finishedAt;
    this.activationDate = activationDate;
    this.inactivationDate = inactivationDate;
    this.duration = duration;
    this.enrollUsers = enrollUsers;
    this.instructors = instructors;
    this.userCertificateUrl = userCertificateUrl;
    this.hasNewContent = hasNewContent;
  }
}

export class EventBasedOnClass {
  eventId: number;
  eventName: string;
  eventImage: string;
  eventImageB64: string;
  eventImageExtension: string;
  eventBannerURL: string;
  eventBannerBase64: string;
  eventBannerExtension: string;
  eventHasCertification: boolean;
  eventClass: EventClass;
  hasNewContent: boolean;
  user?: User;

  constructor(
    eventId: number,
    eventName: string = "",
    eventImage: string = "",
    eventImageB64: string = "",
    eventImageExtension: string = "",
    eventBannerURL: string = "",
    eventBannerBase64: string = "",
    eventBannerExtension: string = "",
    eventHasCertification: boolean = false,
    eventClass: EventClass = new EventClass(),
    user: User = new User(),
    hasNewContent = false
  ) {
    this.eventId = eventId;
    this.eventName = eventName;
    this.eventImage = eventImage;
    this.eventImageB64 = eventImageB64;
    this.eventImageExtension = eventImageExtension;
    this.eventBannerURL = eventBannerURL;
    this.eventBannerBase64 = eventBannerBase64;
    this.eventBannerExtension = eventBannerExtension;
    this.eventHasCertification = eventHasCertification;
    this.eventClass = eventClass;
    this.user = user;
    this.hasNewContent = hasNewContent;
  }
}
